<template>
  <form id="contactForm" v-on:submit.prevent="validateBeforeSubmit" method="post" novalidate>
    <!-- input First Name field -->
    <div class="field">
      <label class="label has-text-raven-grey">First Name *</label>
      <div class="control has-icons-right">
        <input class="input is-rounded"
               data-vv-validate-on="change|blur|input"
               v-on:focus="clearErrorsOnFocusEmpty"
               v-on:keyup.delete="clearErrors"
               v-model="firstName"
               name="firstName"
               type="text"
               placeholder="First Name"
               v-validate="'required|max:50'"
               v-bind:class="errors.has('firstName') ? 'is-danger' : 'is-giada-green'">
        <span class="icon is-right has-text-danger" v-if="errors.has('firstName')">
          <i class="fas fa-exclamation-circle"></i>
        </span>
      </div>
      <!-- error field -->
      <span class="help is-danger"  v-if="errors.has('firstName')">
        {{ errors.first('firstName') }}
      </span>
    </div>

    <!-- input Last Name field -->
    <div class="field">
      <label class="label has-text-raven-grey">Last Name *</label>
      <div class="control has-icons-right">
        <input class="input is-rounded"
               data-vv-validate-on="change|blur|input"
               v-on:focus="clearErrorsOnFocusEmpty"
               v-on:keyup.delete="clearErrors"
               v-model="lastName"
               name="lastName"
               type="text"
               placeholder="Last Name"
               v-validate="'required|max:50'"
               v-bind:class="errors.has('lastName') ? 'is-danger' : 'is-giada-green'">
        <span class="icon is-right has-text-danger" v-if="errors.has('lastName')">
          <i class="fas fa-exclamation-circle"></i>
        </span>
      </div>
      <!-- error field -->
      <span class="help is-danger"  v-if="errors.has('lastName')">
        {{ errors.first('lastName') }}
      </span>
    </div>

    <!-- input Email field -->
    <div class="field">
      <label class="label has-text-raven-grey">Email *</label>
      <div class="control has-icons-right">
        <input class="input is-rounded"
               v-on:focus="clearErrorsOnFocusEmpty"
               v-on:keyup.delete="clearErrors"
               v-model="email"
               name="email"
               type="email"
               placeholder="Email Address"
               v-validate="'required|email|max:50'"
               v-bind:class="errors.has('email') ? 'is-danger' : 'is-giada-green'">
        <span class="icon is-right has-text-danger" v-if="errors.has('email')">
          <i class="fas fa-exclamation-circle"></i>
        </span>
      </div>
      <!-- error field -->
      <span class="help is-danger"  v-if="errors.has('email')">
        {{ errors.first('email') }}
      </span>
    </div>

    <!-- select Subject field -->
    <div class="level is-marginless">
      <b-field :message="errors.first('subject')" label="Subject *" :type="errors.has('subject') ? 'is-danger' : 'is-giada-green'" custom-class="has-text-raven-grey has-icon-right" >
          <b-select placeholder="Select a subject" rounded v-model="subject" v-validate:subject="'required'" data-vv-validate-on="change|blur|input" name="subject">
            <option v-for="(selectOption, index) in selectOptionsSubject" :key="index" :value="selectOption">{{selectOption}}</option>
          </b-select>
      </b-field>

      <div class="level-right">
        <span class="icon is-right has-text-danger" v-if="errors.has('selectSubject')">
          <i class="fas fa-exclamation-circle"></i>
        </span>
      </div>
    </div>

    <!-- textarea Message field -->
    <div class="field">
      <label class="label has-text-raven-grey">Message *</label>
      <div class="control has-icons-right">
        <textarea class="textarea is-rounded"
                  data-vv-validate-on="change|blur|input"
                  v-on:focus="clearErrorsOnFocusEmpty"
                  v-on:keyup.delete="clearErrors"
                  name="message"
                  v-model="message"
                  placeholder="Message"
                  v-validate="'required|max:1000'"
                  v-bind:class="errors.has('message') ? 'is-danger' : 'is-giada-green'">
        </textarea>
        <span class="icon is-right has-text-danger" v-if="errors.has('message')">
          <i class="fas fa-exclamation-circle"></i>
        </span>
      </div>
      <!-- error field -->
      <span class="help is-danger"  v-if="errors.has('message')">
        {{ errors.first('message') }}
      </span>
    </div>

    <!-- checkbox Terms & Conditions field -->
    <div class="field">
      <div class="control has-icons-right">
        <input class="is-checkradio is-giada-green" id="checkboxAgreeTerms" v-validate="'required'" type="checkbox" name="checkboxAgreeTerms">
        <label for="checkboxAgreeTerms" class="checkbox has-text-raven-grey">
          {{checkboxAgreeTermsText}}
          <router-link v-bind:to="checkboxAgreeTermsUrl" exact class="checkbox has-text-tuna-grey">
            {{checkboxAgreeTermsTextLink}}
          </router-link>
        </label>
        <span class="icon checkterms-icon-error is-right has-text-danger" v-if="errors.has('checkboxAgreeTerms')">
          <i class="fas fa-exclamation-circle"></i>
        </span>
      </div>
      <!-- error field -->
      <span class="help is-danger"  v-if="errors.has('checkboxAgreeTerms')">
        {{ errors.first('checkboxAgreeTerms') }}
      </span>
    </div>

    <!-- button Submit field -->
    <div class="field">
      <div class="control">
        <button class="button is-centered is-fullwidth is-rounded is-giada-green">{{button_text}}</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'ContactForm',
  data: function () {
    return {
      button_text: 'Send it now!',
      firstName: '',
      lastName: '',
      email: '',
      subject: null,
      message: '',
      selectPlaceholderSubject: 'Select a subject',
      selectOptionsSubject: [
        'General Information',
        'Investment Inquiry',
        'Partnership Inquiry',
        'Career Opportunities',
        'Press'
      ],
      checkboxAgreeTermsText: 'I agree to the ',
      checkboxAgreeTermsTextLink: 'terms and conditions',
      checkboxAgreeTermsUrl: 'Terms' // ,
      // ipGeo: null
    }
  },
  methods: {
    validateBeforeSubmit: function () {
      let vm = this
      this.$validator.validateAll().then(result => {
        if (result) {
          const loading = this.$loading.open()
          // this.$http.post('http://localhost:5000/landing-page-ver1/us-central1/giadaFunc/contact',
          this.$http.post('https://us-central1-landing-page-ver1.cloudfunctions.net/giadaFunc/contact',
            {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              subject: this.subject,
              message: this.message
            },
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            }
          ).then(() => {
            loading.close()
            this.gtmFormTrack()
            this.$router.push('/')
          }, res => {
            loading.close()
            if (res.body.errors && res.status === 422) {
              Object.keys(res.body.errors).forEach(key => {
                vm.$validator.errors.add(res.body.errors[key].param, vm.$validator.dictionary.getMessage('en', res.body.errors[key].msg.type, [vm.$validator.dictionary.getAttribute('en', res.body.errors[key].param), [res.body.errors[key].msg.extra]]))
              })
            } else {
              let errorCode = res.status === 0 ? 403 : res.status
              this.$router.push({name: 'ErrorPage', params: {'0': '/' + String(errorCode), status: String(errorCode)}})
            }
          })
        }
      })
    },
    // getIp: function () {
    //  this.$http.get('http://ip-api.com/json/?fields=262143').then(response => {
    //    this.ipGeo = response.data
    //  }, err => {
    //    console.log('Houston we have a Problem GET!!!', err)
    //  })
    // },
    gtmFormTrack: function () {
      this.$gtm.trackEvent({
        event: 'newContact',
        category: 'Form Submission',
        action: 'submit',
        label: 'Contact page Contact Form',
        // ipGeo: this.ipGeo,
        dateEvent: new Date(Date.now()),
        value: this.email
      })
    },
    clearErrors: function (item) {
      const field = this.$validator.fields.find(item)
      field.reset()
      return this.$validator.errors.remove(field.name, field.scope)
    },
    clearErrorsOnFocusEmpty: function (event) {
      if (event.target.value === '') {
        this.clearErrors(event.target)
      }
    }
  } // ,
  // mounted () {
  // this.getIp()
  // }
}
</script>

<style scoped>
  .textarea.is-rounded {
    border-radius: 1rem;
  }

  .control.has-icons-right .icon.checkterms-icon-error {
    top: -20%;
  }
</style>



// WEBPACK FOOTER //
// src/components/contactPage/ContactForm.vue